import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
// Sterling is the canonical design system for the Silver Falls suite.
// Tokens load FIRST per Sterling §1.3 — they define the CSS custom
// properties every other layer references. components.css here is
// Anvil's transitional layer: existing screens still use the
// .btn / .badge / .card class system on top of Sterling tokens. As
// Phase C lands, screens swap onto Sterling's React primitives and
// the local components.css shrinks toward zero.
import '@silverfalls/sterling/tokens.css';
import '@silverfalls/sterling/components.css';
import '../../../docs/design/anvil/style-pack/tokens-bridge.css';
import '../../../docs/design/anvil/style-pack/components.css';
import './app.css';
import { App } from './App.js';
import { applySterlingAssetFix } from './sterling-asset-fix.js';

// Sterling's OPCO logo URLs ship as broken relative paths in its CSS.
// Override them with Vite-resolved asset URLs at app boot. See
// sterling-asset-fix.ts for the full explanation.
applySterlingAssetFix();

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Missing #root element in index.html');

createRoot(rootElement).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
